<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商家名称" prop="merchantName">
                <a-input v-model="queryParam.merchantName" :maxLength="32" :placeholder="$t('请输入')+'商家名称'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="经营类型" prop="businessType">
                <a-select :placeholder="$t('请选择')+'经营类型'" v-model="queryParam.businessType" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.BusinessTypeEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商家状态" prop="merchantStatus">
                <a-select :placeholder="$t('请选择')+'商家状态'" v-model="queryParam.merchantStatus" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.MerchantStatusEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="主营行业" prop="industryId">
                <a-cascader :options="industryList"
                            :field-names="{ label: 'categoryName', value: 'id', children: 'children'}"
                            :placeholder="$t('请选择')+'主营行业'"
                            style="width: 100%" v-model="industrySelected" allowClear @change="onIndustryChange">
                </a-cascader>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商家类型" prop="merchantType">
                <a-select :placeholder="$t('请选择')+'商家类型'" v-model="queryParam.merchantType" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.MerchantTypeEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客服电话" prop="customerServiceMobile">
                <a-input v-model="queryParam.customerServiceMobile" :maxLength="32" :placeholder="$t('请输入')+'客服电话'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md=" 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:merchantmerchant:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['merchant:merchantmerchant:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['merchant:merchantmerchant:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList"/>
      <rate-form ref="rateForm" @ok="getList"/>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="merchantLogo" slot-scope="text, record">
          <div>
            <img v-if="record.merchantLogo" :src="record.merchantLogo" style="width:50px;height:50px;" @click="handleRecordPreview(record.merchantLogo)" alt="none"/>
          </div>
        </template>
        <span slot="businessType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.BusinessTypeEnum" :value="record.businessType"/>
        </span>
        <span slot="merchantStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.MerchantStatusEnum" :value="record.merchantStatus"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"  />
          <a @click="jumpLakala(record, undefined)">
             <a-icon type="ordered-list" />子商户
          </a>
          <a-divider type="vertical" v-hasPermi="['merchant:merchantmerchant:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:merchantmerchant:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
         <a-divider type="vertical" v-hasPermi="['merchant:merchantmerchant:platRate']" />
          <a @click="$refs.rateForm.handleAudit(record)" v-hasPermi="['merchant:merchantmerchant:platRate']">
             <a-icon type="edit" />费率
          </a>
         <a-divider type="vertical" v-hasPermi="['merchant:merchantmerchant:settle']" />
          <a @click="handleSettle(record)" v-hasPermi="['merchant:merchantmerchant:settle']">
             <a-icon type="edit" />结算
          </a>
          <a-divider type="vertical" v-hasPermi="['merchant:merchantmerchant:status']" />
          <a @click="handleOn(record)" v-if="record.merchantStatus === 0 " v-hasPermi="['merchant:merchantmerchant:status']">
             <a-icon type="edit" />{{$t('上架')}}
          </a>
          <a @click="handleOff(record)"  v-if="record.merchantStatus === 1 " v-hasPermi="['merchant:merchantmerchant:status']">
             <a-icon type="edit" />{{$t('下架')}}
          </a>
          <br>
          <a-divider type="vertical" v-hasPermi="['merchant:merchantmerchant:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['merchant:merchantmerchant:remove']" v-if="record.id !== '0'">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageMerchantMerchant,listMerchantMerchant, delMerchantMerchant,merchantStatus } from '@/api/merchant/merchantMerchant'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import RateForm from './modules/RateForm'
import { tableMixin } from '@/store/table-mixin'
import {listIndustry} from "@/api/merchant/industry";
import {receiptSell} from "@/api/order/sell";
import {merchantSettle} from "@/api/merchant/merchantAccountBill";

export default {
  name: 'MerchantMerchant',
  components: {
    CustomDictTag,
    CreateForm,
    RateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      industryList:[],
      industrySelected:[],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantName: undefined,
        merchantLogo: undefined,
        merchantBackground: undefined,
        merchantAreax: undefined,
        merchantAddress: undefined,
        merchantStatus: undefined,
        merchantDescription: undefined,
        businessType: undefined,
        longitude: undefined,
        latitude: undefined,
        marginAmount: undefined,
        industryId: undefined,
        timeOfEntry: undefined,
        customerServiceMobile: undefined,
        imgDetail: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: '商家名称',
          dataIndex: 'merchantName',
          align: 'center'
        },
        {
          title: '商家logo',
          dataIndex: 'merchantLogo',
          scopedSlots: { customRender: 'merchantLogo' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '商家所在地',
          dataIndex: 'merchantAreaxName',
          align: 'center'
        },
        {
          title: '商家状态',
          dataIndex: 'merchantStatus',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'merchantStatus' },
          align: 'center'
        },
        {
          title: '经营类型',
          dataIndex: 'businessType',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'businessType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '保证金',
          dataIndex: 'marginAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '余额',
          dataIndex: 'balanceAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '主营行业',
          dataIndex: 'industryName',
          align: 'center'
        },
        {
          title: '入驻时长',
          dataIndex: 'timeOfEntryName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '客服电话',
          dataIndex: 'customerServiceMobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getIndustryList()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    jumpLakala(record) {
      this.$router.push({
        path: '/shop/lakalaApply',
        query: {
            shopId: record.id,
          companyType: 1
        }
      })
    },
    onIndustryChange(value, selectedOptions) {
      this.queryParam.industryId = value[1]
      console.log('onIndustryChange',this.queryParam.industryId)

    },
    getIndustryList() {
      listIndustry({}).then(response => {
        this.industryList = response.data
      })
    },
    /** 查询商家列表 */
    getList () {
      this.loading = true
     pageMerchantMerchant(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantName: undefined,
        merchantLogo: undefined,
        merchantBackground: undefined,
        merchantAreax: undefined,
        merchantAddress: undefined,
        merchantStatus: undefined,
        merchantDescription: undefined,
        businessType: undefined,
        longitude: undefined,
        latitude: undefined,
        marginAmount: undefined,
        industryId: undefined,
        timeOfEntry: undefined,
        customerServiceMobile: undefined,
        imgDetail: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleOn(record) {
      var that = this
      this.$confirm({
        title: '是否确认上架?',
        onOk () {
          return merchantStatus({id:record.id,merchantStatus: 1}).then(() => {
            that.onSelectChange([], [])
            const message = '上架成功'
            that.$message.success(message, 3)
            that.getList()
          })
        },
        onCancel () {}
      })
    },
    handleOff(record) {
      var that = this
      this.$confirm({
        title: '是否确认下架?',
        onOk () {
          return merchantStatus({id:record.id,merchantStatus: 0}).then(() => {
            that.onSelectChange([], [])
            const message = '下架成功'
            that.$message.success(message, 3)
            that.getList()
          })
        },
        onCancel () {}
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delMerchantMerchant(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleSettle(record) {
      var that = this
      this.$confirm({
        title: '是否确认结算?',
        onOk () {
          return merchantSettle({id:record.id}).then(() => {
            that.onSelectChange([], [])
            const message = '结算成功'
            that.$message.success(message, 3)
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('merchant/merchant/export', ...that.queryParam, `商家_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
